export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      let rows = rootGetters[`${parentModule}/elements`](element).rows
      return Object.prototype.hasOwnProperty.call(element, 'row') ? rows[element.row] : rows
    },
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    id: (state, getters) => (element, id = 'id', parentModule) =>  getters.elements(element, parentModule)[id],
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(row => row.id == id),
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
  },
  actions: {
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'layoutRowModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'layoutRowModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'layoutRowModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'layoutRowModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
  }
}